@if (travelHistory) {
  <div>
    <app-carousel>
      <ng-template carouselItem="1">
        <mat-card appearance="outlined" class="mat-card-c my-3">
          <mat-card-content class="mat-body-1">
            <h2 style="display: flex; justify-content: center">
              <strong>Resumen</strong>
            </h2>
            <h3>Nombre ruta: {{ travelHistory.routeName }}</h3>
            <h3>Nombre equipo: {{ travelHistory.equipmentbrand }}</h3>
            <h3>Código equipo: {{ travelHistory.code }}</h3>
            <h3>Realizó usuario: {{ travelHistory.userName }}</h3>
            <h3>Fecha inicio: {{ travelHistory.startDate | dateFormat }}</h3>
            <h3>Fecha fin: {{ travelHistory.endDate | dateFormat }}</h3>
            <h3>Origen: {{ travelHistory.originName }}</h3>
            <h3>Destino: {{ travelHistory.endName }}</h3>
            <h3>Distancia Aproximada en Km: {{ travelHistory.distance }}</h3>
            <h3>Tiempo Aproximado en horas: {{ travelHistory.timeHours }}</h3>
          </mat-card-content>
        </mat-card>
      </ng-template>
      <ng-template carouselItem="2">
        <mat-card appearance="outlined" class="mat-card-c">
          <mat-card-content class="mat-body-1">
            <h2 style="display: flex; justify-content: center">
              <strong>Puntos de control ruta</strong>
            </h2>
            <app-control-pointer
              class="w-100"
              [controlPointer]="originalRoute[0].checkpoints"
              [colorComplete]="colorComplete"
              [viewAddCkeckpoint]="false"
              [isHistorical]="true"
              [isRoute]="true"
            ></app-control-pointer>
          </mat-card-content>
        </mat-card>
      </ng-template>
      <ng-template carouselItem="3">
        <mat-card appearance="outlined" class="mat-card-c">
          <mat-card-content class="mat-body-1">
            <h2 style="display: flex; justify-content: center">
              <strong>Puntos de control viaje</strong>
            </h2>
            <app-control-pointer
              class="w-100"
              [controlPointer]="travelHistory.checkpoints"
              [colorComplete]="colorComplete"
              [colorIncomplete]="colorIncomplete"
              (view)="openAddCheckpointDialog($event)"
              [viewAddCkeckpoint]="false"
              [isHistorical]="true"
            ></app-control-pointer>
          </mat-card-content>
        </mat-card>
      </ng-template>
      <ng-template carouselItem="4">
        <mat-card appearance="outlined" class="mat-card-c">
          <mat-card-content class="mat-body-1">
            <h2 style="display: flex; justify-content: center">
              <strong>Mapa</strong>
            </h2>
            <app-map
              [markers]="markers"
              [routerFinished]="true"
              [searchLocation]="false"
              (routerData)="getRouterData($event)"
            ></app-map>
          </mat-card-content>
        </mat-card>
      </ng-template>
    </app-carousel>
  </div>
}